var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"entity-info-item"},[_c('span',{staticClass:"entity-info-label"},[_vm._v(_vm._s(_vm.label)+"：")]),_vm._t("default",function(){return [_c('span',{staticClass:"entity-info-value"},[_vm._v(_vm._s(_vm.displayValue))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }